import { makeAutoObservable, observable } from "mobx";

import { Filter } from "./filter";

export class PersistedFilter<T, V> implements Filter<T> {
  predicate: (item: T, selected: V[]) => boolean;

  constructor(
    readonly key: string,
    public selected: V[] = [],
    predicate: (item: T, selected: V[]) => boolean = () => true,
  ) {
    this.predicate = predicate;
    makeAutoObservable(this, {
      filter: false,
      predicate: observable.ref,
    });
  }

  filter(item: T): boolean {
    return this.predicate(item, this.selected);
  }

  setPredicate(predicate: (item: T, selected: V[]) => boolean) {
    this.predicate = predicate;
  }

  serialize(): PersistedFilterSerialized<V> {
    return {
      type: "PersistedFilter",
      key: this.key,
      selected: this.selected,
    };
  }

  static deserialize<T, V>(
    serialized: PersistedFilterSerialized<V>,
  ): PersistedFilter<T, V> {
    return new PersistedFilter<T, V>(serialized.key, serialized.selected);
  }
}

export interface PersistedFilterSerialized<V> {
  type: "PersistedFilter";
  key: string;
  selected: V[];
}
